function formatStyledCurrency(valor) {
  // Remover espaços e símbolos monetários (como "R$")
  valor = valor.trim().replace(/[^\d,.-]/g, '');

  // Substituir todos os pontos (que são separadores de milhar) por vazio
  valor = valor.replace(/\./g, '');

  // Substituir a vírgula pelo ponto para transformar em formato decimal
  valor = valor.replace(',', '.');

  // Converter para número decimal
  return parseFloat(valor);
}

export { formatStyledCurrency }